<template>
    <!-- ======= Header ======= -->
    <header id="header" class="fixed-top  td-flex align-items-center">
        <div class="container d-flex align-items-center">

            <div class="logo me-auto mt-4">
                <h1><a href="index.html">{{appName}}</a></h1>
                <!-- Uncomment below if you prefer to use an image logo -->
                <!-- <a href="index.html"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->
            </div>

            <nav id="navbar" class="navbar order-last order-lg-0">
                <ul>
                    <li><a class="nav-link scrollto active" href="#hero">Inicio</a></li>
                    <li><a class="nav-link scrollto" href="#services">API Reference</a></li>
                    <li><a class="nav-link scrollto" href="#pricing">Preço</a></li>
                    <li><a class="nav-link scrollto" href="#contact">Contato</a></li>
                    <li><router-link class="nav-link" to="/login">Login</router-link></li>
                </ul>
                <i class="fa fa-list mobile-nav-toggle"></i>
            </nav><!-- .navbar -->

          <!--   <div class="header-social-links d-flex align-items-center">
                <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
                <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>
                <a href="#" class="instagram"><i class="fa fa-instagram"></i></a>
                <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>
            </div> -->

        </div>
    </header><!-- End Header -->

</template>

<script>

export default {

}
</script>